// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","body":"App_body__PuluK"};